import { ClockModule } from '../../shared/clock/clock.module';
import { CommonModule } from '@angular/common';
import { DropdownsModule } from '../dropdowns/dropdowns.module';
import { ModalCompHeaderComponent } from "./modal-comp-header/modal-comp-header.component";
import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ToastsContainer } from 'src/app/shared/toast/toasts-container.component';

@NgModule({
  declarations: [
    ModalCompHeaderComponent
  ],
  imports: [
    ClockModule,
    CommonModule,
    DropdownsModule,
    SharedModule,
    ToastsContainer
  ],
  exports: [
    ModalCompHeaderComponent
  ],
  providers: [
  ],
  schemas: [
  ]
})

export class ModalComponentsModule {
  constructor() { }
}
